import React, { useEffect, useState } from "react";
import { useAppAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import api from "../utils/axiosInstance";

// Pages
import ShopsPage from "../pages/ShopsPage";
import ShopInfo from "../pages/ShopInfo";

export default function ShopsEntry() {
  const { appUser, loading } = useAppAuth();
  const navigate = useNavigate();
  const [shop, setShop] = useState(null);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    const checkShop = async () => {
      if (!loading && appUser) {
        let role = appUser.role?.toLowerCase() || "seller";

        if (role === "seller") {
          try {
            const res = await api.get("/shops/my");
            if (res.data) {
              // ✅ redirect seller to their shop dashboard
              navigate(`/shops/${res.data.slug}/dashboard`, { replace: true });
            } else {
              setShop(null); // no shop → show create form
            }
          } catch (err) {
            console.error("Failed to fetch shop for seller:", err);
            setShop(null);
          } finally {
            setChecking(false);
          }
        } else {
          setChecking(false);
        }
      }
    };

    checkShop();
  }, [loading, appUser, navigate]);

  if (loading || checking) return <div>Loading...</div>;
  if (!appUser) return <div>Error: user not found</div>;

  const role = appUser.role?.toLowerCase();

  // Admins / Super Admins → see all shops
  if (role === "admin" || role === "super_admin") {
    return <ShopsPage />;
  }

  // Seller without a shop → show create form
  if (role === "seller" && !shop) {
    return (
      <div style={{ padding: 24 }}>
        <ShopInfo
          isNewShop
          shop={{}}
          onShopUpdate={(shop) => {
            navigate(`/shops/${shop.slug}/dashboard`, { replace: true });
          }}
        />
      </div>
    );
  }

  return null; // sellers with shop get redirected already
}
